<template>
  <div>
    <van-tabbar v-model="active" :z-index="99" active-color="#f2494b">
      <van-tabbar-item to="/">
        <span>社区</span>
        <img
          slot="icon"
          slot-scope="props"
          :src="props.active ? community.active : community.normal"
        />
      </van-tabbar-item>

      <van-tabbar-item to="/video">
        <span>影视</span>
        <img slot="icon" slot-scope="props" :src="props.active ? video.active : video.normal" />
      </van-tabbar-item>

      <van-tabbar-item @click="addhot">
        <span>原创</span>
        <img slot="icon" slot-scope="props" :src="props.active ? original.active : original.normal" />
      </van-tabbar-item>

      <van-tabbar-item to="/find">
        <span>发现</span>
        <img slot="icon" slot-scope="props" :src="props.active ? find.active : find.normal" />
      </van-tabbar-item>

      <van-tabbar-item to="/my">
        <span>我的</span>
        <img slot="icon" slot-scope="props" :src="props.active ? my.active : my.normal" />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      community: {
        normal: require("@/assets/icon/community/community1x_M.png"),
        active: require("@/assets/icon/community/community1x_D.png")
      },
      video: {
        normal: require("@/assets/icon/video/video1x_M.png"),
        active: require("@/assets/icon/video/video1x_D.png")
      },
      original: {
        normal: require("@/assets/icon/original/original3x.png"),
        active: require("@/assets/icon/original/original3x.png")
      },
      find: {
        normal: require("@/assets/icon/find/find1x_M.png"),
        active: require("@/assets/icon/find/find1x_D.png")
      },
      my: {
        normal: require("@/assets/icon/my/my1x_M.png"),
        active: require("@/assets/icon/my/my1x_D.png")
      }
    };
  },
  methods: {
    addhot() {
      if (sessionStorage.getItem("userData")) {
        this.$router.push("/hot");
      } else {
        this.$router.push("./login");
      }
    }
  },
  mounted() {
    if (this.$route.path == "/community") {
      this.active = 0;
    } else if (this.$route.path == "/video") {
      this.active = 1;
    } else if (
      this.$route.path == "/hot" ||
      this.$route.path == "/latest" ||
      this.$route.path == "/focusOn"
    ) {
      this.active = 2;
    } else if (this.$route.path == "/find") {
      this.active = 3;
    } else if (this.$route.path == "/my") {
      this.active = 4;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/common/tabbar.vue